export default __webpack_public_path__ + "static/flavor-citrus-berry-24ed3bda6e6a4a0c304b006d30a20de7.svg";